module.exports = __webpack_public_path__ + "static/media/branding-logo-topbar.354c1427.png";